import React from 'react'
import Link from 'gatsby-link'
import './Header.css'

export default function Header() {
  return (
    <div className="Header__container">
      <h1>
        <Link to="/">Kat Park</Link>
      </h1>
      <div className="Header__links">
        <Link to="/makeup">Makeup</Link>
        <Link to="/hair">Hair</Link>
        <Link to="/hair-makeup">Hair & Makeup</Link>
        <Link to="/hair-color">Hair Color</Link>
        <Link to="/bridal">Bridal</Link>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js